/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectedAppsResponse } from '../models/ConnectedAppsResponse';
import type { InitiateConnectionRequest } from '../models/InitiateConnectionRequest';
import type { InitiateConnectionResponse } from '../models/InitiateConnectionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ConnectedProvidersService {
    /**
     * Initiate an OAuth connection to a provider
     * Start a proactive OAuth linking flow; returns the SP authorization URL.
     *
     * Tenant and the acting user are propagated to session-broker via gRPC metadata.
     * @param requestBody
     * @param userSession
     * @returns InitiateConnectionResponse Successful Response
     * @throws ApiError
     */
    public static initiateConnection(
        requestBody: InitiateConnectionRequest,
        userSession?: (string | null),
    ): CancelablePromise<InitiateConnectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/connected-providers:initiate',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List the connectors the user is assigned to, with their connection status
     * @param userSession
     * @returns ConnectedAppsResponse Successful Response
     * @throws ApiError
     */
    public static listConnectedApps(
        userSession?: (string | null),
    ): CancelablePromise<ConnectedAppsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/connected-apps',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke the current user's connection to a provider
     * @param providerId
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static revokeConnectedApp(
        providerId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/connected-apps/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
